const state = {
  isVisible: false,
  overlayComponent: null,
  overlayTitle: '',
  overlayProps: {}
}

const mutations = {
  SET_OVERLAY_VISIBLE(state, isVisible) {
    console.log('Vuex overlay: SET_OVERLAY_VISIBLE', isVisible)
    state.isVisible = isVisible
  },
  SET_OVERLAY_COMPONENT(state, component) {
    console.log('Vuex overlay: SET_OVERLAY_COMPONENT', component)
    state.overlayComponent = component
  },
  SET_OVERLAY_TITLE(state, title) {
    console.log('Vuex overlay: SET_OVERLAY_TITLE', title)
    state.overlayTitle = title
  },
  SET_OVERLAY_PROPS(state, props) {
    console.log('Vuex overlay: SET_OVERLAY_PROPS', props)
    state.overlayProps = props
  }
}

const actions = {
  openOverlay({ commit }, { component, title, props = {} }) {
    console.log('=== VUEX OVERLAY: openOverlay ===')
    console.log('Component:', component)
    console.log('Title:', title)
    console.log('Props:', props)
    
    commit('SET_OVERLAY_COMPONENT', component)
    commit('SET_OVERLAY_TITLE', title)
    commit('SET_OVERLAY_PROPS', props)
    commit('SET_OVERLAY_VISIBLE', true)
    
    console.log('Overlay state after openOverlay:', {
      isVisible: true,
      overlayComponent: component,
      overlayTitle: title,
      overlayProps: props
    })
  },
  
  updateOverlayData({ commit, state }, { title, subtitle, image }) {
    console.log('=== VUEX OVERLAY: updateOverlayData ===')
    console.log('Title:', title)
    console.log('Subtitle:', subtitle)
    console.log('Image:', image)
    
    commit('SET_OVERLAY_TITLE', title)
    
    // Preserve existing props and only update subtitle and image
    const updatedProps = {
      ...state.overlayProps,
      subtitle,
      image
    }
    commit('SET_OVERLAY_PROPS', updatedProps)
    
    console.log('Overlay data updated with props:', updatedProps)
  },
  
  closeOverlay({ commit, state }) {
    console.log('=== VUEX OVERLAY: closeOverlay ===')
    
    try {
      // First, set visibility to false to trigger transition
      commit('SET_OVERLAY_VISIBLE', false)
      
      // Clear component and props after a short delay to allow transition
      setTimeout(() => {
        try {
          commit('SET_OVERLAY_COMPONENT', null)
          commit('SET_OVERLAY_TITLE', '')
          commit('SET_OVERLAY_PROPS', {})
          console.log('Overlay component and props cleared')
        } catch (error) {
          console.error('Error clearing overlay component:', error)
        }
      }, 300) // Match transition duration
      
      console.log('Overlay close process completed')
    } catch (error) {
      console.error('Error during overlay close:', error)
      // Force cleanup even if there's an error
      commit('SET_OVERLAY_VISIBLE', false)
      commit('SET_OVERLAY_COMPONENT', null)
      commit('SET_OVERLAY_TITLE', '')
      commit('SET_OVERLAY_PROPS', {})
    }
  },
  
  debugOverlayState({ state }) {
    console.log('=== VUEX OVERLAY: DEBUG STATE ===')
    console.log('Current overlay state:', {
      isVisible: state.isVisible,
      overlayComponent: state.overlayComponent,
      overlayTitle: state.overlayTitle,
      overlayProps: state.overlayProps
    })
  },
  
  resetOverlayState({ commit }) {
    console.log('=== VUEX OVERLAY: RESET STATE ===')
    commit('SET_OVERLAY_VISIBLE', false)
    commit('SET_OVERLAY_COMPONENT', null)
    commit('SET_OVERLAY_TITLE', '')
    commit('SET_OVERLAY_PROPS', {})
    console.log('Overlay state reset')
  }
}

const getters = {
  isVisible: state => state.isVisible,
  overlayComponent: state => state.overlayComponent,
  overlayTitle: state => state.overlayTitle,
  overlayProps: state => state.overlayProps
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} 